import { TableSkeleton } from '@components/medicus-ui/Loaders';
import type { ReporteAbmWebRow } from '@lib/services/reporteAbmWeb';
import { fechaCorta } from '@lib/utils/fecha';

interface TablaProps {
  rows: ReporteAbmWebRow[];
  loading?: boolean;
}

export function ReporteAbmWebTabla({ rows, loading }: TablaProps) {
  if (loading) return <TableSkeleton rows={6} />;

  if (rows.length === 0) {
    return <p className="text-element-mid">No se encontraron resultados con los filtros seleccionados.</p>;
  }

  return (
    <div className="tableWrap">
      <table className="dataTable">
        <thead>
          <tr>
            <th>Legajo</th>
            <th>DNI</th>
            <th>Nombre / Apellido</th>
            <th>Parentesco</th>
            <th>Medicard</th>
            <th>Estado Persona</th>
            <th>Estado Legajo</th>
            <th>Vigencia Alta</th>
            <th>Vigencia Baja</th>
            <th>Plan Real</th>
            <th>Motivo</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={`${r.legajoId}:${r.asociadoId}`}>
              <td style={{ fontWeight: 600 }}>{r.legajo || '—'}</td>
              <td>{r.dni || '—'}</td>
              <td style={{ fontWeight: 500 }}>{r.nombre}</td>
              <td>{r.parentesco}</td>
              <td style={{ fontFamily: 'monospace', fontSize: 12 }}>{r.medicard || '—'}</td>
              <td>
                <span style={{ color: r.estadoPersona === 'Activo' ? '#166534' : '#92400e', fontWeight: 600 }}>
                  {r.estadoPersona}
                </span>
              </td>
              <td>
                <span style={{ color: r.estadoLegajo === 'Activo' ? '#166534' : '#92400e', fontWeight: 600 }}>
                  {r.estadoLegajo}
                </span>
              </td>
              <td>{fechaCorta(r.vigenciaAlta)}</td>
              <td>
                {r.bajaFutura ? (
                  <span style={{ color: '#92400e' }}>Baja (futura) {fechaCorta(r.vigenciaBaja)}</span>
                ) : (
                  fechaCorta(r.vigenciaBaja)
                )}
              </td>
              <td style={{ color: 'var(--color-element-mid)' }}>{r.planReal || '—'}</td>
              <td style={{ color: 'var(--color-element-mid)' }}>{r.motivo || '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
